import LandingPage from '../components/LandingPage';

const faqItems = [
  {
    q: '¿Cuánto tiempo me tomará salir de deudas?',
    a: 'Depende de tu saldo, tasa de interés y cuánto pagas cada mes. Con una deuda de $50,000 MXN al 36% anual, pagando solo el mínimo puede tomarte más de 10 años. Pagando $500–$1,000 extra al mes puedes lograrlo en 2–3 años y ahorrar miles en intereses.',
  },
  {
    q: '¿Cuál es la forma más rápida de pagar mis deudas?',
    a: 'El método avalancha — pagar primero la deuda con la tasa de interés más alta — te ahorra más dinero en total. El método bola de nieve — pagar primero la deuda más pequeña — te da victorias rápidas y mantiene la motivación. Ambos son mucho mejores que pagar solo el mínimo.',
  },
  {
    q: '¿Qué es el método bola de nieve para pagar deudas?',
    a: 'El método bola de nieve consiste en pagar los mínimos en todas tus deudas y destinar todo el dinero extra a la deuda más pequeña primero. Al liquidarla, ese pago se suma a la siguiente deuda más pequeña. Así la "bola de nieve" crece con cada deuda que eliminas, acelerando tu salida de deudas.',
  },
  {
    q: '¿Debo ahorrar dinero o pagar mis deudas primero?',
    a: 'Si tus deudas tienen tasas superiores al 10% anual (tarjetas de crédito, créditos personales), generalmente conviene pagarlas antes de ahorrar. Primero crea un fondo de emergencia pequeño (1–2 meses de gastos), luego enfoca todo el dinero extra en eliminar tus deudas de mayor interés.',
  },
];

const sections = [
  {
    heading: 'Cómo usar esta calculadora de deudas',
    body: 'Ingresa cada deuda: tu saldo actual, la tasa de interés anual y el pago mínimo mensual. Luego añade cualquier monto extra que puedas destinar al pago. La calculadora muestra tu fecha de liberación de deudas, el total de intereses pagados y cómo se comparan diferentes estrategias para salir de deudas más rápido.',
  },
  {
    heading: 'Por qué los pagos mínimos te cuestan tanto dinero',
    body: 'El interés de las tarjetas de crédito se acumula mensualmente sobre tu saldo pendiente. Con una tasa del 36% anual — común en tarjetas mexicanas — una deuda de $30,000 MXN pagando solo el mínimo puede tardarte más de 8 años y costarte más de $40,000 en intereses. Agregar aunque sea $300–$500 extra al mes cambia el panorama completamente.',
  },
];

export default function SalirDeDeudas() {
  return (
    <LandingPage
      locale="es-mx"
      pageUrl="https://clearmydebt.app/salir-de-deudas/"
      helmet={{
        lang: 'es',
        title: 'Calculadora para Salir de Deudas Gratis | ClearMyDebt',
        description: 'Calcula exactamente cuánto tiempo te tomará salir de deudas. Sin registro, resultados instantáneos.',
        ogTitle: 'Calculadora para Salir de Deudas Gratis | ClearMyDebt',
        ogDescription: 'Calcula exactamente cuánto tiempo te tomará salir de deudas. Sin registro, resultados instantáneos.',
      }}
      hreflangList={[
        { hreflang: 'es-mx', href: 'https://clearmydebt.app/salir-de-deudas/' },
        { hreflang: 'es-es', href: 'https://clearmydebt.app/salir-de-deudas/' },
        { hreflang: 'x-default', href: 'https://clearmydebt.app/salir-de-deudas/' },
      ]}
      h1="Calculadora para Salir de Deudas — Conoce tu Fecha Libre"
      intro="Ingresa tus deudas y descubre exactamente cuándo terminarás de pagarlas — y cuánto dinero ahorrarás eligiendo la estrategia correcta."
      sections={sections}
      faqItems={faqItems}
      faqHeading="Preguntas Frecuentes"
      moreHeading="Más calculadoras"
      moreLinks={[
        { href: '/es-mx/credit-card-payoff-calculator/', label: 'Calculadora tarjeta de crédito' },
        { href: '/es-mx/debt-snowball-calculator/', label: 'Método bola de nieve' },
        { href: '/es-mx/debt-avalanche-calculator/', label: 'Método avalancha' },
        { href: '/es-mx/debt-repayment-calculator/', label: 'Calculadora de pagos' },
      ]}
    />
  );
}
